module.exports = __webpack_public_path__ + "img/51.220da1de.png";